import React from "react";
import { useSearchParams } from "react-router-dom";
import CourseNoteSessions from "../../components/content/course-note/course-note-sessions/CourseNoteSessions";

export default function CourseNoteSessionsRoute() {
    const [searchParams] = useSearchParams();
    const courseNoteId = searchParams.get("courseNoteId") ?? searchParams.get("trainingCourseId");

    if (courseNoteId == null) {
        return null;
    }

    return <CourseNoteSessions courseNoteId={Number(courseNoteId)} />;
}
